// extracted by mini-css-extract-plugin
export default {"color-salmon":"#F5B9A1","colorSalmon":"#F5B9A1","promoArea":"Rr7gc fmngK","promoIcon":"_86xTj","promoText":"pcIil hRgdS U6k72","promoTCsIcon":"q9sTJ","promoTCs":"Hlriq"};